/**
 * Links in terminal output (Terminal board card 4, 21.10.2026). URLs are
 * underlined on hover (`@xterm/addon-web-links`); like VS Code's terminal,
 * Ctrl+click (⌘+click on macOS) opens one in the browser — a plain click
 * stays a click, so selecting text across a URL still works. Right-click on a
 * link offers "Open link" and, while the API Client is on, "Open as request".
 * Pure helpers; the add-on is loaded in utils/terminalAddons.js.
 */

/** True when a click on a link should open it. */
export function isOpenLinkClick(e, isMac) {
  if (!e || e.button > 0) return false;
  return isMac ? !!e.metaKey : !!e.ctrlKey;
}

/** Only http(s) URLs become requests. */
export function isRequestUrl(uri) {
  return /^https?:\/\/[^\s/]+/i.test(String(uri || ''));
}

/**
 * The URL as the shell printed it, without the punctuation a sentence or a
 * log line wraps it in ("see https://x.test/a)." → https://x.test/a).
 */
export function cleanLink(uri) {
  let u = String(uri || '');
  while (/[.,;:!?'"]$/.test(u)) u = u.slice(0, -1);
  const opens = (u.match(/\(/g) || []).length;
  const closes = (u.match(/\)/g) || []).length;
  if (closes > opens && u.endsWith(')')) u = u.slice(0, -1);
  return u;
}
